//
//
//
//
//
//
//
//
//
//
//
//
//

import { FieldDataSelect, getFlowTaskData } from '@/api/workFlow/FlowEngine';
export default {
  name: 'relationFlow',
  props: ['value', 'flowId', 'field'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function data() {
    return {
      options: [],
      innerValue: this.value
    };
  },
  created: function created() {
    var _this = this;
    if (!this.flowId) return;
    FieldDataSelect(this.flowId).then(function (res) {
      _this.options = res.data.list;
    });
    this.onChange(this.innerValue);
  },
  watch: {
    innerValue: function innerValue(val) {
      val && this.$emit('change', val);
    },
    value: function value(val) {
      this.innerValue = val;
    }
  },
  methods: {
    onChange: function onChange(val) {
      var _this2 = this;
      if (!this.field || !this.flowId) return;
      var relationData = this.$store.state.generator.relationData;
      if (val) {
        getFlowTaskData(this.flowId, val).then(function (res) {
          if (!res.data) return;
          _this2.$set(relationData, _this2.field, res.data);
          _this2.$store.commit('generator/UPDATE_RELATION_DATA', relationData);
        });
      } else {
        this.$set(relationData, this.field, {});
        this.$store.commit('generator/UPDATE_RELATION_DATA', relationData);
      }
    }
  }
};